import { env } from 'lib/env';

export const showNoDsp = env.REACT_APP_SHOW_NO_DSP === 'true';
